import React, { useState, useEffect } from "react";
import { useFormik, FormikProvider, Form, Field, ErrorMessage } from "formik";
import * as bie from "react-bootstrap";
import { BiTrash } from "react-icons/bi";
import { VscDiffAdded } from "react-icons/vsc";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import { failureAlert } from "../../CommonUtils/SweetAlerts";
import Swal from "sweetalert2";
import { ImagePdfBucket } from "../../CommonUtils/ImagesBase64";
import { FaEye } from "react-icons/fa";
import { viewImage } from "../../CommonUtils/viewImage";
import * as Yup from "yup";
import allowNumbersOnly from "../../CommonUtils/CommonValidations";

const CUTOFF_YEAR = 2021;

const FinancialResources = ({ data, paymentDone, type }) => {
    console.log("type", type)
    console.log("dataa", data.length)
    const length = data.length
    const [pgCourse, setPgCourse] = useState([]);
    const [clgYear, setClgYear] = useState("");
    const [ugData, setUgData] = useState(null);
    const [pgData, setPgData] = useState(null);

    // Fetch PG Courses
    const GetPGCourses = () => {
        CommonAxiosGet(`${config.url.FAC_URL}getPGCourses`).then((res) => {
            if (res?.data?.scode === "01") {
                setPgCourse(res.data.data);
            } else {
                setPgCourse([]);
            }
        });
    };

    //   const getAfterSubmit = () => {
    //     CommonAxiosGet(`${config.url.FAC_URL}getcoursesFdrDetails?type=${type}`).then((res) => {
    //       if (res?.data?.scode === "01") {
    //         setPgCourse(res.data.data);
    //       } else {
    //         setPgCourse([]);
    //       }
    //     });
    //   };
    const getAfterSubmit = () => {
        CommonAxiosGet(`${config.url.FAC_URL}getcoursesFdrDetails?type=${type}`).then((res) => {
            if (res?.data?.scode === "01" && res.data.data?.length > 0) {
                const fetchedData = res.data.data;

                // Filter data based on cousre_type if needed
                const ugData = fetchedData.filter(item => item.cousre_type === type);
                const pgData = fetchedData.filter(item => item.cousre_type === "PG");

                // Map UG data
                const mappedUGData = ugData.map((item) => ({
                    periodFrom: item.period_from || "",
                    periodTo: item.period_to || "",
                    fdrType: item.fdr_type || "",
                    fdrBankNumber: item.fdr_bank_number || "",
                    corpusDate: item.corpus_date || "",
                    bankAddress: item.bank_address || "",
                    ifsc: item.ifsc || "",
                    uploadFdr: item.upload_fdr || "",
                    amount: item.amount || "",
                    courseId: item.course_id || "",
                }));

                // Map PG data (if needed)
                const mappedPGData = pgData.map((item) => ({
                    periodFrom: item.period_from || "",
                    periodTo: item.period_to || "",
                    fdrType: item.fdr_type || "",
                    fdrBankNumber: item.fdr_bank_number || "",
                    corpusDate: item.corpus_date || "",
                    bankAddress: item.bank_address || "",
                    ifsc: item.ifsc || "",
                    uploadFdr: item.upload_fdr || "",
                    amount: item.amount || "",
                    courseId: item.course_id || "",
                    dateMaturity: item.date_maturity || "",
                    dateRenewal: item.date_renewal || "",
                }));

                // Set to Formik
                if (mappedUGData.length > 0) {
                    formik.setFieldValue("coursesfdr", mappedUGData);
                }
                if (mappedPGData.length > 0) {
                    formik.setFieldValue("pgDetails", mappedPGData);
                }
            }
        });
    };
    // Fetch College Type
    const GetClgtype = () => {
        CommonAxiosGet(`${config.url.FAC_URL}getCourseTypes`).then((res) => {
            if (res?.data?.scode === "01") {
                const collegeData = res.data.data || [];
                const ug = collegeData.find((d) => d.course_type === "UG") || "";
                const pg = collegeData.find((d) => d.course_type === "PG") || "";
                setUgData(ug);
                setPgData(pg);
                if (ug?.year_of_establishment) {
                    setClgYear(String(ug.year_of_establishment));
                }
            }
        });
    };

    useEffect(() => {
        GetPGCourses();
        GetClgtype();
        getAfterSubmit();
    }, []);

    const havUG = true;
    const havPG = !!pgData;
    const estYear = parseInt(clgYear) || 0;
    const isBefore = estYear > 0 && estYear <= CUTOFF_YEAR;
    const showPGCorpus = havUG && havPG;

    // Initialize Formik with data from props
    // const getInitialUGDetails = () => {
    //     if (data && data.length > 0) {
    //         return data.map((item) => ({
    //             courseId: item.courseId || item.course_id || "",
    //             amount: item.amount || "",
    //             periodFrom: item.periodFrom || item.period_from || "",
    //             periodTo: item.periodTo || item.period_to || "",
    //             fdrType: item.fdrType || item.fdr_type || "FDR",
    //             fdrBankNumber: item.fdrBankNumber || item.fdr_bank_number || "",
    //             corpusDate: item.corpusDate || item.corpus_date || "",
    //             bankAddress: item.bankAddress || item.bank_address || "",
    //             ifsc: item.ifsc || "",
    //             uploadFdr: item.uploadFdr || item.upload_fdr || "",

    //         }));
    //     }
    //     return [
    //         {
    //             courseId: "",
    //             amount: "",
    //             periodFrom: "",
    //             periodTo: "",
    //             fdrType: "FDR",
    //             fdrBankNumber: "",
    //             corpusDate: "",
    //             bankAddress: "",
    //             ifsc: "",
    //             uploadFdr: "",
    //         },
    //     ];
    // };
    const getInitialUGDetails = () => {
        // Always return exactly 1 row - ignore the data prop for initial rendering
        return [
            {
                courseId: "",
                amount: "",
                periodFrom: "",
                periodTo: "",
                fdrType: "FDR",
                fdrBankNumber: "",
                corpusDate: "",
                bankAddress: "",
                ifsc: "",
                uploadFdr: "",
            },
        ];
    };
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            programSanction: "Yes",
            coursesfdr: getInitialUGDetails(),
            pgDetails: [
                {
                    courseId: "",
                    amount: "",
                    periodFrom: "",
                    periodTo: "",
                    fdrType: "",
                    fdrBankNumber: "",
                    corpusDate: "",
                    bankAddress: "",
                    ifsc: "",
                    dateMaturity: "",
                    dateRenewal: "",
                    uploadFdr: "",
                },
            ],
        },
        validationSchema: Yup.object().shape({
            coursesfdr: Yup.array().of(
                Yup.object().shape({
                    periodFrom: Yup.string().required("From date is required"),
                    periodTo: Yup.string().required("To date is required"),
                    fdrBankNumber: Yup.string().required("FDR/Bank Guarantee No. is required"),
                    corpusDate: Yup.string().required("Date is required"),
                    bankAddress: Yup.string().required("Bank address is required"),
                    ifsc: Yup.string().required("IFSC is required"),
                    uploadFdr: Yup.string().required("Upload is required"),
                    amount: Yup.string().required("Amount is required"),
                })
            ),
        }),
        // validationSchema: Yup.object().shape({
        //   coursesfdr: Yup.array().of(
        //     Yup.object().shape({
        //       periodFrom: Yup.string().required("From date is required"),
        //       periodTo: Yup.string().required("To date is required"),
        //       fdrType: Yup.string().required("FDR Type is required"),
        //       fdrBankNumber: Yup.string().required("FDR/Bank Guarantee No. is required"),
        //       corpusDate: Yup.string().required("Date is required"),
        //       bankAddress: Yup.string().required("Bank address is required"),
        //       ifsc: Yup.string().required("IFSC is required"),
        //       uploadFdr: Yup.string().required("Upload is required"),
        //     })
        //   ),
        //   pgDetails: Yup.array().when("programSanction", {
        //     is: "Yes",
        //     then: () =>
        //       Yup.array().of(
        //         Yup.object().shape({
        //           courseId: Yup.string().required("Course is required"),
        //           amount: Yup.string().required("Amount is required"),
        //           periodFrom: Yup.string().required("From date is required"),
        //           periodTo: Yup.string().required("To date is required"),
        //           fdrType: Yup.string().required("FDR Type is required"),
        //           fdrBankNumber: Yup.string().required("FDR/Bank Guarantee No. is required"),
        //           corpusDate: Yup.string().required("Date is required"),
        //           bankAddress: Yup.string().required("Bank address is required"),
        //           ifsc: Yup.string().required("IFSC is required"),
        //           dateMaturity: Yup.string().required("Date of Maturity is required"),
        //           dateRenewal: Yup.string().required("Date of Renewal is required"),
        //           uploadFdr: Yup.string().required("Upload is required"),
        //         })
        //       ),
        //     otherwise: () => Yup.array().notRequired(),
        //   }),
        // }),
        // onSubmit: (values) => {
        //     // Check for validation errors
        //     if (Object.keys(formik.errors).length > 0) {
        //         Swal.fire({
        //             icon: "warning",
        //             title: "Validation Error",
        //             text: "Please fill all required fields correctly before submitting.",
        //         });
        //         return;
        //     }

        //     Swal.fire({
        //         text: "Are you sure you want to submit?",
        //         icon: "warning",
        //         showCancelButton: true,
        //         confirmButtonText: "Yes, submit it!",
        //         cancelButtonText: "No, cancel!",
        //     }).then((result) => {
        //         if (result.isConfirmed) {
        //             const payload = {
        //                 coursesfdr: values.coursesfdr.map(item => ({
        //                     ...item,
        //                     cousreType: type
        //                 })),

        //                 cousreType: type,
        //             };
        //             let url = config.url.FAC_URL + `savecoursesFdrDetails`;
        //             CommonAxiosPost(url, payload)
        //                 .then((res) => {
        //                     if (res?.data?.scode === "01") {
        //                         Swal.fire("Submitted Successfully!", "", "success");
        //                         getAfterSubmit();
        //                     } else {
        //                         failureAlert("Failed to submit");
        //                     }
        //                 })
        //                 .catch((err) => {
        //                     console.error("Submission error:", err);
        //                     failureAlert("An error occurred while submitting");
        //                 });
        //         }
        //     });
        // },
        onSubmit: (values) => {
            console.log("========== SUBMIT TRIGGERED ==========");
            console.log("Data length:", data?.length);

            // Get the length from props
            const courseLength = data?.length || 0;
            console.log("Course length:", courseLength);

            // ========== CALCULATE TOTAL AMOUNT FROM ALL ROWS ==========
            let totalAmount = 0;
            for (let i = 0; i < values.coursesfdr.length; i++) {
                const amountValue = values.coursesfdr[i].amount;
                const amount = parseFloat(amountValue);
                if (!isNaN(amount)) {
                    totalAmount += amount;
                }
                console.log(`Row ${i + 1} - Amount: ${amountValue}, Parsed: ${amount}`);
            }

            console.log("TOTAL AMOUNT:", totalAmount);

            // ========== AMOUNT VALIDATION BASED ON TOTAL ==========
            let hasAmountError = false;
            let errorMessage = "";
            let requiredAmount = 0;

            // Check based on number of courses
            if (courseLength === 1) {
                requiredAmount = 250000;
                if (isNaN(totalAmount) || totalAmount < requiredAmount) {
                    hasAmountError = true;
                    errorMessage = `For ${courseLength} course, the total amount must be at least ₹2.5 Lakhs (₹250,000). Your total amount: ₹${totalAmount.toLocaleString('en-IN')}`;
                }
            }
            else if (courseLength === 2) {
                requiredAmount = 350000;
                if (isNaN(totalAmount) || totalAmount < requiredAmount) {
                    hasAmountError = true;
                    errorMessage = `For ${courseLength} courses, the total amount must be at least ₹3.5 Lakhs (₹350,000). Your total amount: ₹${totalAmount.toLocaleString('en-IN')}`;
                }
            }
            else if (courseLength === 3) {
                requiredAmount = 500000;
                if (isNaN(totalAmount) || totalAmount < requiredAmount) {
                    hasAmountError = true;
                    errorMessage = `For ${courseLength} courses, the total amount must be at least ₹5 Lakhs (₹500,000). Your total amount: ₹${totalAmount.toLocaleString('en-IN')}`;
                }
            }

            console.log("Required amount:", requiredAmount);
            console.log("Total amount:", totalAmount);
            console.log("Has amount error:", hasAmountError);

            // Check for form validation errors
            if (Object.keys(formik.errors).length > 0) {
                Swal.fire({
                    icon: "warning",
                    title: "Validation Error",
                    text: "Please fill all required fields correctly before submitting.",
                });
                return;
            }

            // Show amount validation error if exists
            if (hasAmountError) {
                Swal.fire({
                    icon: "warning",
                    title: "Amount Validation Error",
                    html: `
                        <div style="text-align: left;">
                            <p style="color: #d9534f; margin-bottom: 10px; font-size: 16px;">
                                <strong>${errorMessage}</strong>
                            </p>
                            <hr style="margin: 10px 0;" />
                            <p style="font-size: 14px; color: #666;">
                                <strong>📌 Required Fee Structure:</strong><br/>
                                • 1 course: ₹2.5 Lakhs (₹250,000)<br/>
                                • 2 courses: ₹3.5 Lakhs (₹350,000)<br/>
                                • 3 courses: ₹4 Lakhs (₹500,000)
                            </p>
                            <p style="font-size: 14px; color: #666; margin-top: 10px;">
                                <strong>Your Total:</strong> ₹${totalAmount.toLocaleString('en-IN')}
                            </p>
                        </div>
                    `,
                    confirmButtonText: "OK",
                    confirmButtonColor: "#d33",
                });
                return;
            }

            // If validation passes, show confirmation
            Swal.fire({
                text: `Total amount: ₹${totalAmount.toLocaleString('en-IN')}. Are you sure you want to submit?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, submit it!",
                cancelButtonText: "No, cancel!",
            }).then((result) => {
                if (result.isConfirmed) {
                    const payload = {
                        coursesfdr: values.coursesfdr.map(item => ({
                            ...item,
                            cousreType: type
                        })),
                        cousreType: type,
                    };
                    let url = config.url.FAC_URL + `savecoursesFdrDetails`;
                    CommonAxiosPost(url, payload)
                        .then((res) => {
                            if (res?.data?.scode === "01") {
                                Swal.fire("Submitted Successfully!", "", "success");
                                getAfterSubmit();
                            } else {
                                failureAlert("Failed to submit");
                            }
                        })
                        .catch((err) => {
                            console.error("Submission error:", err);
                            failureAlert("An error occurred while submitting");
                        });
                }
            });
        },
    });

    const { values, setFieldValue, errors, touched } = formik;

    // Add row to UG table
    const addUGRow = () => {
        const blank = {
            courseId: "",
            amount: "",
            periodFrom: "",
            periodTo: "",
            fdrType: "",
            fdrBankNumber: "",
            corpusDate: "",
            bankAddress: "",
            ifsc: "",
            uploadFdr: "",
        };
        setFieldValue("coursesfdr", [...values.coursesfdr, blank]);
    };

    // Remove row from UG table
    const removeUGRow = (index) => {
        const rows = values.coursesfdr;
        if (rows.length > 1) {
            setFieldValue("coursesfdr", rows.filter((_, i) => i !== index));
        }
    };

    // Add row to PG table
    const addPGRow = () => {
        const blank = {
            courseId: "",
            amount: "",
            periodFrom: "",
            periodTo: "",
            fdrType: "",
            fdrBankNumber: "",
            corpusDate: "",
            bankAddress: "",
            ifsc: "",
            dateMaturity: "",
            dateRenewal: "",
            uploadFdr: "",
        };
        setFieldValue("pgDetails", [...values.pgDetails, blank]);
    };

    // Remove row from PG table
    const removePGRow = (index) => {
        const rows = values.pgDetails;
        if (rows.length > 1) {
            setFieldValue("pgDetails", rows.filter((_, i) => i !== index));
        }
    };

    return (
        <div className="faculty-form-wrapper">
            <div className="faculty-card">
                <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                        {/* UG Courses Table */}
                        <div
                            className="alert alert-info mb-3 p-3 small"
                            style={{
                                backgroundColor: '#e6f7ff',
                                borderLeft: '4px solid #1890ff',
                                fontSize: '1.1rem',
                                fontWeight: '500',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#d4eaff';
                                e.currentTarget.style.borderLeftWidth = '6px';
                                e.currentTarget.style.fontSize = '1.15rem';
                                e.currentTarget.style.transform = 'scale(1.01)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#e6f7ff';
                                e.currentTarget.style.borderLeftWidth = '4px';
                                e.currentTarget.style.fontSize = '1.1rem';
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <strong className="text-danger fw-20" style={{ fontSize: '20px' }}>📌 Note:</strong> FDR Amount for  ₹2L for 1 course, ₹3.5L for 2 courses, and ₹5L for 3 courses.
                        </div>
                        <bie.Row className="mb-4">
                            <bie.Col md={12}>
                                <h6 className="innerheader-new mb-3">
                                    <span>Financial Resources for proposed programs</span>
                                </h6>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-sm align-middle">
                                        <thead className="table-primary">
                                            <tr className="text-center">
                                                <th style={{ width: "5%" }}>Sl. No.</th>
                                                {/* {type === "New Program" ?
                                                    <>
                                                        <th style={{ width: "15%" }}>Programme</th>
                                                        <th style={{ width: "15%" }}>Courses</th>
                                                    </>
                                                    : (<></>)} */}
                                                <th style={{ width: "12%" }}>Period (From - To)</th>
                                                {/* <th style={{ width: "10%" }}>Select FDR / Bank Guarantee</th> */}
                                                <th style={{ width: "12%" }}>FDR / Bank Guarantee No.</th>
                                                <th>Amount</th>
                                                <th style={{ width: "8%" }}>Date</th>
                                                <th style={{ width: "12%" }}>Bank Name & Address</th>
                                                <th style={{ width: "8%" }}>IFSC</th>
                                                <th style={{ width: "10%" }}>Upload FDR / Bank Guarantee</th>
                                                <th style={{ width: "5%" }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {values.coursesfdr.map((row, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">{index + 1}</td>

                                                    {/* Programme - Display from data prop */}
                                                    {/* {type === "New Program" ?
                                                        <>

                                                            <td>
                                                                {data?.[index]?.courseGroupName ||
                                                                    data?.[index]?.course_cat_name ||
                                                                    data?.[index]?.programme ||
                                                                    "-"}
                                                            </td>

                                                          
                                                            <td>
                                                                {data?.[index]?.courseName && data?.[index]?.courseTypeName
                                                                    ? `${data[index].courseName} - ${data[index].courseTypeName}`
                                                                    : data?.[index]?.courseName ||
                                                                    data?.[index]?.courseTypeName ||
                                                                    data?.[index]?.course_name ||
                                                                    "-"}
                                                            </td>
                                                        </>
                                                        : (<></>)} */}


                                                    {/* Period From - To */}
                                                    <td>
                                                        <div className="d-flex gap-1 align-items-center">
                                                            <Field
                                                                type="date"
                                                                name={`coursesfdr[${index}].periodFrom`}
                                                                className={`form-control form-control-sm ${errors?.coursesfdr?.[index]?.periodFrom &&
                                                                    touched?.coursesfdr?.[index]?.periodFrom
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                            />
                                                            <span>–</span>
                                                            <Field
                                                                type="date"
                                                                name={`coursesfdr[${index}].periodTo`}
                                                                className={`form-control form-control-sm ${errors?.coursesfdr?.[index]?.periodTo &&
                                                                    touched?.coursesfdr?.[index]?.periodTo
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                            />
                                                        </div>
                                                        <ErrorMessage
                                                            name={`coursesfdr[${index}].periodFrom`}
                                                            component="div"
                                                            className="text-danger small mt-1"
                                                        />
                                                        <ErrorMessage
                                                            name={`coursesfdr[${index}].periodTo`}
                                                            component="div"
                                                            className="text-danger small mt-1"
                                                        />
                                                    </td>

                                                    {/* FDR Type */}
                                                    {/* <td>
                                                        <Field
                                                            as="select"
                                                            name={`coursesfdr[${index}].fdrType`}
                                                            className={`form-control form-control-sm ${errors?.coursesfdr?.[index]?.fdrType &&
                                                                    touched?.coursesfdr?.[index]?.fdrType
                                                                    ? "is-invalid"
                                                                    : ""
                                                                }`}
                                                                type="hidden"
                                                        >
                                                            <option value="">--Select Type--</option>
                                                            <option value="FDR">FDR</option>
                                                            <option value="Bank Guarantee">Bank Guarantee</option>
                                                        </Field>
                                                        <ErrorMessage
                                                            name={`coursesfdr[${index}].fdrType`}
                                                            component="div"
                                                            className="text-danger small mt-1"
                                                        />
                                                    </td> */}

                                                    {/* FDR/Bank Guarantee No. */}
                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`coursesfdr[${index}].fdrBankNumber`}
                                                            className={`form-control form-control-sm ${errors?.coursesfdr?.[index]?.fdrBankNumber &&
                                                                touched?.coursesfdr?.[index]?.fdrBankNumber
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                            placeholder="FDR No / Bank Guarantee No."
                                                        />
                                                        <ErrorMessage
                                                            name={`coursesfdr[${index}].fdrBankNumber`}
                                                            component="div"
                                                            className="text-danger small mt-1"
                                                        />
                                                    </td>
                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`coursesfdr[${index}].amount`}
                                                            className={`form-control form-control-sm ${errors?.coursesfdr?.[index]?.amount &&
                                                                touched?.coursesfdr?.[index]?.amount
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                            placeholder="Amount"
                                                        />
                                                        <ErrorMessage
                                                            name={`coursesfdr[${index}].amount`}
                                                            component="div"
                                                            className="text-danger small mt-1"
                                                        />
                                                    </td>

                                                    {/* Date */}
                                                    <td>
                                                        <Field
                                                            type="date"
                                                            name={`coursesfdr[${index}].corpusDate`}
                                                            className={`form-control form-control-sm ${errors?.coursesfdr?.[index]?.corpusDate &&
                                                                touched?.coursesfdr?.[index]?.corpusDate
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                        />
                                                        <ErrorMessage
                                                            name={`coursesfdr[${index}].corpusDate`}
                                                            component="div"
                                                            className="text-danger small mt-1"
                                                        />
                                                    </td>

                                                    {/* Bank Address */}
                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`coursesfdr[${index}].bankAddress`}
                                                            className={`form-control form-control-sm ${errors?.coursesfdr?.[index]?.bankAddress &&
                                                                touched?.coursesfdr?.[index]?.bankAddress
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                            placeholder="Bank Name & Address"
                                                        />
                                                        <ErrorMessage
                                                            name={`coursesfdr[${index}].bankAddress`}
                                                            component="div"
                                                            className="text-danger small mt-1"
                                                        />
                                                    </td>

                                                    {/* IFSC */}
                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`coursesfdr[${index}].ifsc`}
                                                            className={`form-control form-control-sm ${errors?.coursesfdr?.[index]?.ifsc &&
                                                                touched?.coursesfdr?.[index]?.ifsc
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                            placeholder="IFSC Code"
                                                        />
                                                        <ErrorMessage
                                                            name={`coursesfdr[${index}].ifsc`}
                                                            component="div"
                                                            className="text-danger small mt-1"
                                                        />
                                                    </td>

                                                    {/* Upload */}
                                                    <td>
                                                        <input
                                                            type="file"
                                                            className="form-control form-control-sm"
                                                            accept="application/pdf"
                                                            onChange={(e) => {
                                                                let filename = `uploadFdr_${index}`;
                                                                let path = "/Uploads/FDRDocuments/";
                                                                ImagePdfBucket(
                                                                    e,
                                                                    formik,
                                                                    path,
                                                                    //   `coursesfdr[${index}].uploadFdr`,
                                                                    `coursesfdr[${index}].uploadFdr`,
                                                                    filename,
                                                                    "pdf"
                                                                );
                                                                formik.setFieldTouched(
                                                                    `coursesfdr[${index}].uploadFdr`,
                                                                    true
                                                                );
                                                            }}
                                                        />
                                                        <ErrorMessage
                                                            name={`coursesfdr[${index}].uploadFdr`}
                                                            component="div"
                                                            className="text-danger small mt-1"
                                                        />
                                                        {values.coursesfdr[index]?.uploadFdr && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-sm mt-1"
                                                                onClick={() =>
                                                                    viewImage(values.coursesfdr[index].uploadFdr)
                                                                }
                                                            >
                                                                <FaEye /> View
                                                            </button>
                                                        )}
                                                    </td>

                                                    {/* Action Buttons */}
                                                    <td className="text-center">
                                                        {index === 0 ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-success btn-sm"
                                                                onClick={addUGRow}
                                                            >
                                                                <VscDiffAdded />
                                                            </button>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => removeUGRow(index)}
                                                            >
                                                                <BiTrash />
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </bie.Col>
                        </bie.Row>

                        {/* PG Corpus Fund Table */}
                        {showPGCorpus && (
                            <bie.Row className="mb-4">
                                <bie.Col md={12}>
                                    <h6 className="innerheader-new mb-3">
                                        <span>PG Corpus Fund</span>
                                    </h6>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-sm align-middle">
                                            <thead className="table-success">
                                                <tr className="text-center">
                                                    <th style={{ width: "5%" }}>Sl. No.</th>
                                                    <th style={{ width: "12%" }}>Programme</th>
                                                    <th style={{ width: "8%" }}>Amount (₹)</th>
                                                    <th style={{ width: "10%" }}>Period (From - To)</th>
                                                    <th style={{ width: "10%" }}>Select FDR / Bank Guarantee</th>
                                                    <th style={{ width: "10%" }}>FDR / Bank Guarantee No.</th>
                                                    <th style={{ width: "8%" }}>Date</th>
                                                    <th style={{ width: "12%" }}>Bank Name & Address</th>
                                                    <th style={{ width: "8%" }}>IFSC</th>
                                                    <th style={{ width: "8%" }}>Date of Maturity</th>
                                                    <th style={{ width: "8%" }}>Date of Renewal</th>
                                                    <th style={{ width: "10%" }}>Upload</th>
                                                    <th style={{ width: "5%" }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {values.pgDetails.map((row, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">{index + 1}</td>

                                                        {/* Programme */}
                                                        <td>
                                                            <Field
                                                                as="select"
                                                                name={`pgDetails[${index}].courseId`}
                                                                className={`form-control form-control-sm ${errors?.pgDetails?.[index]?.courseId &&
                                                                    touched?.pgDetails?.[index]?.courseId
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                            >
                                                                <option value="">--Select Programme--</option>
                                                                {pgCourse.map((course) => (
                                                                    <option key={course.course_id} value={course.course_id}>
                                                                        {course.course_name}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <ErrorMessage
                                                                name={`pgDetails[${index}].courseId`}
                                                                component="div"
                                                                className="text-danger small mt-1"
                                                            />
                                                        </td>

                                                        {/* Amount */}
                                                        <td>
                                                            <Field
                                                                type="text"
                                                                name={`pgDetails[${index}].amount`}
                                                                className={`form-control form-control-sm ${errors?.pgDetails?.[index]?.amount &&
                                                                    touched?.pgDetails?.[index]?.amount
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                                placeholder="Amount"
                                                                onKeyPress={allowNumbersOnly}
                                                            />
                                                            <ErrorMessage
                                                                name={`pgDetails[${index}].amount`}
                                                                component="div"
                                                                className="text-danger small mt-1"
                                                            />
                                                        </td>

                                                        {/* Period From - To */}
                                                        <td>
                                                            <div className="d-flex gap-1 align-items-center">
                                                                <Field
                                                                    type="date"
                                                                    name={`pgDetails[${index}].periodFrom`}
                                                                    className={`form-control form-control-sm ${errors?.pgDetails?.[index]?.periodFrom &&
                                                                        touched?.pgDetails?.[index]?.periodFrom
                                                                        ? "is-invalid"
                                                                        : ""
                                                                        }`}
                                                                />
                                                                <span>–</span>
                                                                <Field
                                                                    type="date"
                                                                    name={`pgDetails[${index}].periodTo`}
                                                                    className={`form-control form-control-sm ${errors?.pgDetails?.[index]?.periodTo &&
                                                                        touched?.pgDetails?.[index]?.periodTo
                                                                        ? "is-invalid"
                                                                        : ""
                                                                        }`}
                                                                />
                                                            </div>
                                                            <ErrorMessage
                                                                name={`pgDetails[${index}].periodFrom`}
                                                                component="div"
                                                                className="text-danger small mt-1"
                                                            />
                                                            <ErrorMessage
                                                                name={`pgDetails[${index}].periodTo`}
                                                                component="div"
                                                                className="text-danger small mt-1"
                                                            />
                                                        </td>

                                                        {/* FDR Type */}
                                                        <td>
                                                            <Field
                                                                as="select"
                                                                name={`pgDetails[${index}].fdrType`}
                                                                className={`form-control form-control-sm ${errors?.pgDetails?.[index]?.fdrType &&
                                                                    touched?.pgDetails?.[index]?.fdrType
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                            >
                                                                <option value="">--Select Type--</option>
                                                                <option value="FDR">FDR</option>
                                                                <option value="Bank Guarantee">Bank Guarantee</option>
                                                            </Field>
                                                            <ErrorMessage
                                                                name={`pgDetails[${index}].fdrType`}
                                                                component="div"
                                                                className="text-danger small mt-1"
                                                            />
                                                        </td>

                                                        {/* FDR/Bank Guarantee No. */}
                                                        <td>
                                                            <Field
                                                                type="text"
                                                                name={`pgDetails[${index}].fdrBankNumber`}
                                                                className={`form-control form-control-sm ${errors?.pgDetails?.[index]?.fdrBankNumber &&
                                                                    touched?.pgDetails?.[index]?.fdrBankNumber
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                                placeholder="FDR No / Bank Guarantee No."
                                                            />
                                                            <ErrorMessage
                                                                name={`pgDetails[${index}].fdrBankNumber`}
                                                                component="div"
                                                                className="text-danger small mt-1"
                                                            />
                                                        </td>

                                                        {/* Date */}
                                                        <td>
                                                            <Field
                                                                type="date"
                                                                name={`pgDetails[${index}].corpusDate`}
                                                                className={`form-control form-control-sm ${errors?.pgDetails?.[index]?.corpusDate &&
                                                                    touched?.pgDetails?.[index]?.corpusDate
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                            />
                                                            <ErrorMessage
                                                                name={`pgDetails[${index}].corpusDate`}
                                                                component="div"
                                                                className="text-danger small mt-1"
                                                            />
                                                        </td>

                                                        {/* Bank Address */}
                                                        <td>
                                                            <Field
                                                                type="text"
                                                                name={`pgDetails[${index}].bankAddress`}
                                                                className={`form-control form-control-sm ${errors?.pgDetails?.[index]?.bankAddress &&
                                                                    touched?.pgDetails?.[index]?.bankAddress
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                                placeholder="Bank Name & Address"
                                                            />
                                                            <ErrorMessage
                                                                name={`pgDetails[${index}].bankAddress`}
                                                                component="div"
                                                                className="text-danger small mt-1"
                                                            />
                                                        </td>

                                                        {/* IFSC */}
                                                        <td>
                                                            <Field
                                                                type="text"
                                                                name={`pgDetails[${index}].ifsc`}
                                                                className={`form-control form-control-sm ${errors?.pgDetails?.[index]?.ifsc &&
                                                                    touched?.pgDetails?.[index]?.ifsc
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                                placeholder="IFSC Code"
                                                            />
                                                            <ErrorMessage
                                                                name={`pgDetails[${index}].ifsc`}
                                                                component="div"
                                                                className="text-danger small mt-1"
                                                            />
                                                        </td>

                                                        {/* Date of Maturity */}
                                                        <td>
                                                            <Field
                                                                type="date"
                                                                name={`pgDetails[${index}].dateMaturity`}
                                                                className={`form-control form-control-sm ${errors?.pgDetails?.[index]?.dateMaturity &&
                                                                    touched?.pgDetails?.[index]?.dateMaturity
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                            />
                                                            <ErrorMessage
                                                                name={`pgDetails[${index}].dateMaturity`}
                                                                component="div"
                                                                className="text-danger small mt-1"
                                                            />
                                                        </td>

                                                        {/* Date of Renewal */}
                                                        <td>
                                                            <Field
                                                                type="date"
                                                                name={`pgDetails[${index}].dateRenewal`}
                                                                className={`form-control form-control-sm ${errors?.pgDetails?.[index]?.dateRenewal &&
                                                                    touched?.pgDetails?.[index]?.dateRenewal
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                            />
                                                            <ErrorMessage
                                                                name={`pgDetails[${index}].dateRenewal`}
                                                                component="div"
                                                                className="text-danger small mt-1"
                                                            />
                                                        </td>

                                                        {/* Upload */}
                                                        <td>
                                                            <input
                                                                type="file"
                                                                className="form-control form-control-sm"
                                                                accept="application/pdf"
                                                                onChange={(e) => {
                                                                    ImagePdfBucket(
                                                                        e,
                                                                        formik,
                                                                        "/Uploads/FDRDocuments/",
                                                                        `pgDetails[${index}].uploadFdr`,
                                                                        `pgUpload_${index}`,
                                                                        "pdf"
                                                                    );
                                                                    formik.setFieldTouched(
                                                                        `pgDetails[${index}].uploadFdr`,
                                                                        true
                                                                    );
                                                                }}
                                                            />
                                                            <ErrorMessage
                                                                name={`pgDetails[${index}].uploadFdr`}
                                                                component="div"
                                                                className="text-danger small mt-1"
                                                            />
                                                            {values.pgDetails[index]?.uploadFdr && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-sm mt-1"
                                                                    onClick={() =>
                                                                        viewImage(values.pgDetails[index].uploadFdr)
                                                                    }
                                                                >
                                                                    <FaEye /> View
                                                                </button>
                                                            )}
                                                        </td>

                                                        {/* Action Buttons */}
                                                        <td className="text-center">
                                                            {index === 0 ? (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success btn-sm"
                                                                    onClick={addPGRow}
                                                                >
                                                                    <VscDiffAdded />
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() => removePGRow(index)}
                                                                >
                                                                    <BiTrash />
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </bie.Col>
                            </bie.Row>
                        )}

                        {/* Submit Button */}
                        <bie.Row>
                            <bie.Col className="d-flex justify-content-end">
                                {paymentDone ? (
                                    <div style={{ color: "green", fontWeight: "bold" }}>
                                        ✅ Already submitted
                                    </div>
                                ) : (
                                    <button type="submit" className="btn btn-primary">
                                        Submit
                                    </button>
                                )}
                            </bie.Col>
                        </bie.Row>
                    </Form>
                </FormikProvider>
            </div>
        </div>
    );
};

export default FinancialResources;